import { Notification } from '@app/components/various/Notification';
import { fetchMarketsRequest } from '@app/ducks';
import { cn } from '@app/utils/cn';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useNavigationSettingsContext } from '../NavigationSettingsContext';

import { AddedList } from './lists/AddedList';
import { AvailableList } from './lists/AvailableList';
interface Props {
  isLoadingSettings: boolean;
}

export const MenuSection = ({ isLoadingSettings }: Props) => {
  const dispatch = useDispatch();
  const { hasItemWithoutMarkets, isLoadingPages, isMarketsMismatch, isUnavailablePage, warningsOrder, isLoadingMarkets } =
    useNavigationSettingsContext();

  const { t } = useTranslation(['common', 'settings']);

  React.useEffect(() => {
    dispatch(fetchMarketsRequest());
  }, [dispatch]);

  const isLoadingData = isLoadingMarkets || isLoadingPages || isLoadingSettings;

  const reverseWarnings = warningsOrder.missingPage > warningsOrder.missingMarket;

  return (
    <section className="box space-y-5">
      <h3 className="heading-3">{t('settings:navigation_menu')}</h3>
      <p className="text-neutral-40 body-2">{t('settings:navigation_menu_help')}</p>
      <div
        className={cn('mt-3 flex flex-col gap-3', {
          'flex-col-reverse': reverseWarnings,
        })}
      >
        {isUnavailablePage && <Notification type="warning" message={t('settings:missing_page')} />}
        {isMarketsMismatch && <Notification type="warning" message={t('settings:missing_market_in_common')} />}
        {hasItemWithoutMarkets && <Notification type="warning" message={t('settings:missing_markets')} />}
      </div>
      <div className="flex flex-col gap-5 md:flex-row">
        <AvailableList isLoading={isLoadingData} />
        <AddedList isLoading={isLoadingData} />
      </div>
    </section>
  );
};
